// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
.section_guest {
  display: flex;
  justify-content: center;
}
.section_guest .innerBox {
  position: relative;
}
.section_guest.isWeb {
  margin-top: 2em;
}
.section_guest.isWeb .innerBox {
  border-radius: 30px;
  padding: 60px 80px;
  min-height: 80vh;
  width: 500px;
  box-sizing: border-box;
}
.section_guest.isNative {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.section_guest.isNative .innerBox {
  width: 100%;
  padding: 20px;
}
.section_guest .btn {
  border-radius: 20px;
  width: auto;
  font-weight: bold;
  padding: 16px 44px;
}
.section_guest .innerBox {
  background: var(--c_backgroundBox);
}
.section_guest h1 {
  color: var(--c_textBody);
  margin-bottom: 0;
  font-weight: bold;
  font-size: 1.3125em;
}
.section_guest .time {
  display: flex;
  margin: 2em 0;
}
.section_guest .time.disabled {
  opacity: 0.5;
}
.section_guest .time visiba-svg {
  flex-shrink: 0;
  width: 35px;
  margin-right: 10px;
}
.section_guest .time .text {
  flex-grow: 1;
  top: -5px;
  position: relative;
}
.section_guest .time .text b {
  font-weight: 600;
}
.section_guest .textInfo {
  min-height: 200px;
  margin-bottom: 2em;
}
.section_guest .textInfo__link {
  margin-top: 2em;
  text-align: center;
}
.section_guest .textInfo__link a {
  width: 55%;
  display: inline-block;
}
.section_guest .lobbyInfo {
  text-align: center;
  font-weight: bold;
}
.section_guest .signOut,
.section_guest .startCall {
  text-align: center;
  margin-top: 2em;
}
.section_guest .error {
  font-weight: bold;
}
.section_guest .bottomSectionWrap {
  position: absolute;
  bottom: 100px;
  width: 100%;
  left: 0;
}

.guestOverlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #ffffff;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
}
.guestOverlay p {
  text-align: center;
  font-size: 1.25rem;
  font-weight: bold;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
